import React, { Component } from 'react';
import { connect } from 'react-redux';

import Login from './login-component';

import { checkAuthorization } from './actions';
import { generateFileUrl } from '../../apiHelper';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class UserMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false
    }
    this.toggleMenu = this.toggleMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  componentWillMount() {
    let { global, dispatch } = this.props;
    //If user has been logged in recently see if validation token is still good
    if (global.token) {
      dispatch(checkAuthorization());
    }

    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidUpdate(oldProps) {
    let { global } = this.props;
    if (global.errors && global.errors.length > 0
      && global.errors.filter(e => e.errType === 'login').length > 0) {
      window.location = '/app/#/login?e=1';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  showMenu() {
    this.setState({ showMenu: true });
  }

  hideMenu() {
    this.setState({ showMenu: false });
  }

  toggleMenu() {
    let showMenu = !this.state.showMenu;
    this.setState({ showMenu: showMenu });
  }

  clickHandler({ target }) {
    if (document.getElementsByClassName('user-menu-container')[0].contains(target)) {
      //Nothing needs to be done
    } else {
      this.hideMenu();
    }
  }

  renderUserOptions(user) {
    return (
      <ul className="user-menu-container-inner-authenticated">
        <li><h5>{user.firstName} {user.lastName ? user.lastName.substr(0, 1) : ''}.</h5></li>
        <li><a href={`/app/#/dashboard`} onClick={this.hideMenu}>Dashboard</a></li>
        {user.userType !== 'admin' && (<li><a href={`/app/#/profile/${user._id}`} onClick={this.hideMenu}>View / Edit Profile</a></li>)}
        {user.userType !== 'admin' && (<li><a href={`/app/#/dashboard/account`} onClick={this.hideMenu}>Account Settings</a></li>)}
        <li><a href={`/app/#/logout`} onClick={this.hideMenu}>Log Out</a></li>
      </ul>
    );
  }

  render() {
    let { width } = this.state;
    let user = this.props.dashboard.user;

    let isMobile = width <= 576;

    let onMouseEnter = isMobile ? undefined : this.showMenu;
    let onMouseExit = isMobile ? undefined : this.hideMenu;
    let onMouseClick = isMobile ? this.toggleMenu : undefined;

    let userImgSrc = "/wp-content/themes/college-weekends/images/user-icon.svg";
    if (user && user.profile && user.profile.photo) { userImgSrc = generateFileUrl(user.profile.photo, user._id) }
    let toggledClass = this.state.showMenu ? "toggled" : "";
    let impersonationClass = (this.props.global && user && this.props.global.impersonating) ? "impersonation" : "";

    return (
      <div className={toggledClass} onMouseEnter={onMouseEnter} onMouseLeave={onMouseExit} onClick={onMouseClick} >
        <button className={`user-menu-toggle ${impersonationClass}`} aria-controls="primary-menu" aria-expanded="false">
          <img className="user" src={userImgSrc} />
        </button>
        {this.state.showMenu && (
          <div className="user-menu-container d-block">
            <button className="menu-close" onClick={this.hideMenu}></button>
            <span className="user-menu-inner">
              {user ? this.renderUserOptions(user) : (<Login onSubmit={this.hideMenu} />)}
            </span>
          </div>
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps)(UserMenu);
